import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_SITES: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_SITES_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_SITES_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.SITE_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.SITE_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.SITE_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.SITE_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.SITE_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
